import axios from "axios"

const fetchSingleSaloonRequest = () => {
	return {type: "FETCH_SINGLE_SALOOON_REQUEST"}
}

const fetchSingleSaloonSuccess = (single_saloon) => {
	return {type: "FETCH_SINGLE_SALOOON_SUCCESS", payload: single_saloon}
}

const fetchSingleSaloonFailure = (error) => {
	return {type: "FETCH_SINGLE_SALOOON_FAILURE", payload: error}
}

export const fetchSingleSaloon = (id) => {
	return (dispatch) => {
		dispatch(fetchSingleSaloonRequest())
        axios.get(`p/saloon/${id}`)
		.then(response => {
			const single_saloon = response.data
			dispatch(fetchSingleSaloonSuccess(single_saloon))	
		})
		.catch(err => {
			const error = err.message
			dispatch(fetchSingleSaloonFailure(error))	
		})
	}
}